export default __webpack_public_path__ + "static/media/logo-us-alo.ebf8d249.svg";